var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.333252C7.80004 0.333252 0.333374 7.79992 0.333374 16.9999C0.333374 26.1999 7.80004 33.6666 17 33.6666C26.2 33.6666 33.6667 26.1999 33.6667 16.9999C33.6667 7.79992 26.2 0.333252 17 0.333252ZM17 5.33325C19.7667 5.33325 22 7.56659 22 10.3333C22 13.0999 19.7667 15.3333 17 15.3333C14.2334 15.3333 12 13.0999 12 10.3333C12 7.56659 14.2334 5.33325 17 5.33325ZM17 28.9999C12.8334 28.9999 9.15004 26.8666 7.00004 23.6333C7.05004 20.3166 13.6667 18.4999 17 18.4999C20.3167 18.4999 26.95 20.3166 27 23.6333C24.85 26.8666 21.1667 28.9999 17 28.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatarIcon.d8801fb60cdb02305e0f93d0e139f73b.svg";
export { ForwardRef as ReactComponent };